import { EscalationSettings } from './EscalationSettings';
import { BuildSettings } from './BuildSettings';

// Combined admin page — the Escalation target AND the Build hand-off (assignee + watchers) on one screen.
// Reuses the two existing section components as-is (no logic duplication), stacked with a divider.
export function HandoffSettings() {
  return (
    <div className="space-y-10">
      <EscalationSettings />
      <div className="border-t border-slate-100" />
      <BuildSettings />
    </div>
  );
}
